export interface Chapter {
  id: number;
  title: string;
  number: number;
  createdAt: string;
}

export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string;
  categorySlug: string;
  tags: string[];
  rating: number;
  views: number;
  likes: number;
  description: string;
  chapters: Chapter[];
  status: string;
  updatedAt: string;
  createdAt: string;
}

export interface Category {
  name: string;
  slug: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  { name: '恋爱', slug: 'romance', icon: 'ri-heart-line', count: 3 },
  { name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line', count: 3 },
  { name: '动作', slug: 'action', icon: 'ri-sword-line', count: 3 },
  { name: '悬疑', slug: 'mystery', icon: 'ri-search-eye-line', count: 3 },
  { name: '都市', slug: 'urban', icon: 'ri-building-line', count: 3 },
  { name: '历史', slug: 'historical', icon: 'ri-ancient-gate-line', count: 3 },
  { name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line', count: 3 },
  { name: '恐怖', slug: 'horror', icon: 'ri-ghost-line', count: 3 },
];

export const comics: Comic[] = [
  {
    id: 1,
    title: '秘密花园',
    author: '金秀妍',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romance%20comic%20cover%20with%20beautiful%20couple%20in%20flower%20garden%2C%20soft%20pastel%20colors%2C%20romantic%20atmosphere%2C%20clean%20illustration%20style%2C%20warm%20lighting%2C%20detailed%20character%20design&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['恋爱', '校园', '甜宠'],
    rating: 9.5,
    views: 1280000,
    likes: 86500,
    description: '平凡的高中生林小美在某天偶然进入了学校后山的秘密花园，在那里遇见了神秘美少年辰逸。两人在花园中度过的每一个午后，都让彼此的心越来越近。然而，辰逸身上隐藏的秘密，却让这段纯真的感情充满了未知的挑战。一段关于青春、秘密与成长的浪漫故事就此展开。',
    chapters: [
      { id: 101, title: '第1话 秘密的入口', number: 1, createdAt: '2026-01-15' },
      { id: 102, title: '第2话 花园的主人', number: 2, createdAt: '2026-01-22' },
      { id: 103, title: '第3话 意外的告白', number: 3, createdAt: '2026-01-29' },
      { id: 104, title: '第4话 夏日的约定', number: 4, createdAt: '2026-02-05' },
      { id: 105, title: '第5话 隐藏的心意', number: 5, createdAt: '2026-02-12' },
      { id: 106, title: '第6话 雨中的吻', number: 6, createdAt: '2026-02-19' },
      { id: 107, title: '第7话 真相的边缘', number: 7, createdAt: '2026-02-26' },
      { id: 108, title: '第8话 不能说的秘密', number: 8, createdAt: '2026-03-05' },
    ],
    status: '连载中',
    updatedAt: '2026-08-03',
    createdAt: '2026-01-15',
  },
  {
    id: 2,
    title: '星之契约者',
    author: '李星辰',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20fantasy%20comic%20cover%20with%20magical%20stars%20and%20constellations%2C%20mysterious%20hero%20with%20glowing%20eyes%2C%20cosmic%20background%2C%20dark%20blue%20and%20gold%20color%20scheme%2C%20detailed%20illustration&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['奇幻', '魔法', '冒险'],
    rating: 9.7,
    views: 2560000,
    likes: 142000,
    description: '在遥远的星之大陆，每一个人类都与一颗星辰签订了契约。少年星痕在成年礼上意外契约了传说中的灭世之星，从此踏上了寻找真相的冒险之旅。他将在旅途中结识同伴、对抗黑暗势力，并逐渐揭开星之契约背后隐藏的惊天秘密。',
    chapters: [
      { id: 201, title: '第1话 星辰之约', number: 1, createdAt: '2025-11-01' },
      { id: 202, title: '第2话 灭世之星', number: 2, createdAt: '2025-11-08' },
      { id: 203, title: '第3话 启程之日', number: 3, createdAt: '2025-11-15' },
      { id: 204, title: '第4话 风之谷的试炼', number: 4, createdAt: '2025-11-22' },
      { id: 205, title: '第5话 暗影逼近', number: 5, createdAt: '2025-11-29' },
      { id: 206, title: '第6话 同伴的力量', number: 6, createdAt: '2025-12-06' },
    ],
    status: '连载中',
    updatedAt: '2026-08-02',
    createdAt: '2025-11-01',
  },
  {
    id: 3,
    title: '暗夜追踪者',
    author: '朴志勋',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20action%20comic%20cover%20with%20noir%20cityscape%2C%20detective%20character%20in%20trench%20coat%2C%20dark%20alley%20atmosphere%2C%20dramatic%20lighting%2C%20gritty%20urban%20style%2C%20moody%20color%20palette&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    tags: ['动作', '悬疑', '都市'],
    rating: 9.3,
    views: 1890000,
    likes: 98000,
    description: '前特种兵韩宇在退役后成为了一名私家侦探。首尔夜晚的街头，犯罪与正义的较量从未停止。当他接手一桩看似普通的失踪案时，却意外揭开了一个横跨整个韩国的庞大犯罪网络。在黑暗的都市丛林中，他将用自己的方式捍卫正义。',
    chapters: [
      { id: 301, title: '第1话 夜幕降临', number: 1, createdAt: '2026-02-10' },
      { id: 302, title: '第2话 失踪的女人', number: 2, createdAt: '2026-02-17' },
      { id: 303, title: '第3话 地下世界', number: 3, createdAt: '2026-02-24' },
      { id: 304, title: '第4话 追击', number: 4, createdAt: '2026-03-03' },
      { id: 305, title: '第5话 真相浮现', number: 5, createdAt: '2026-03-10' },
    ],
    status: '连载中',
    updatedAt: '2026-08-01',
    createdAt: '2026-02-10',
  },
  {
    id: 4,
    title: '第七感',
    author: '崔敏雅',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20mystery%20thriller%20comic%20cover%20with%20eerie%20atmosphere%2C%20female%20protagonist%20looking%20over%20shoulder%2C%20dark%20corridor%2C%20suspenseful%20mood%2C%20cold%20color%20tones%2C%20psychological%20thriller%20aesthetic&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    category: '悬疑',
    categorySlug: 'mystery',
    tags: ['悬疑', '心理', '推理'],
    rating: 9.6,
    views: 2150000,
    likes: 125000,
    description: '心理医生姜素拉拥有一种特殊的能力——她能看到别人看不到的"第七感"。每当她接触患者时，就能看到他们内心最深处的恐惧。当她接手一位声称自己杀过人但却毫无记忆的患者时，一场惊心动魄的心理博弈就此展开。真相究竟藏在记忆的哪个角落？',
    chapters: [
      { id: 401, title: '第1话 特殊患者', number: 1, createdAt: '2026-03-01' },
      { id: 402, title: '第2话 记忆碎片', number: 2, createdAt: '2026-03-08' },
      { id: 403, title: '第3话 镜中人', number: 3, createdAt: '2026-03-15' },
      { id: 404, title: '第4话 催眠', number: 4, createdAt: '2026-03-22' },
      { id: 405, title: '第5话 第七感的觉醒', number: 5, createdAt: '2026-03-29' },
      { id: 406, title: '第6话 另一个我', number: 6, createdAt: '2026-04-05' },
      { id: 407, title: '第7话 真相之门', number: 7, createdAt: '2026-04-12' },
    ],
    status: '连载中',
    updatedAt: '2026-07-31',
    createdAt: '2026-03-01',
  },
  {
    id: 5,
    title: '江南之恋',
    author: '尹智恩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20urban%20romance%20comic%20cover%20with%20modern%20Seoul%20cityscape%2C%20young%20professional%20couple%2C%20fashionable%20clothing%2C%20night%20city%20lights%2C%20sophisticated%20style%2C%20warm%20neon%20aesthetic&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    category: '都市',
    categorySlug: 'urban',
    tags: ['都市', '职场', '恋爱'],
    rating: 9.4,
    views: 1650000,
    likes: 92000,
    description: '在首尔江南区的一家顶级广告公司里，新人策划师金荷娜与创意总监宋在宇的相遇，就像火星撞地球。一个是初出茅庐的热血新人，一个是业界闻名的冷面天才。在激烈的职场竞争中，两人从针锋相对到彼此欣赏，一段关于成长与爱情的都市故事在江南的霓虹灯下徐徐展开。',
    chapters: [
      { id: 501, title: '第1话 入职第一天', number: 1, createdAt: '2026-04-01' },
      { id: 502, title: '第2话 创意总监的刁难', number: 2, createdAt: '2026-04-08' },
      { id: 503, title: '第3话 深夜加班', number: 3, createdAt: '2026-04-15' },
      { id: 504, title: '第4话 竞标大战', number: 4, createdAt: '2026-04-22' },
      { id: 505, title: '第5话 意外的温柔', number: 5, createdAt: '2026-04-29' },
    ],
    status: '连载中',
    updatedAt: '2026-08-03',
    createdAt: '2026-04-01',
  },
  {
    id: 6,
    title: '朝鲜风云录',
    author: '姜太浩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20historical%20comic%20cover%20with%20Joseon%20dynasty%20warrior%2C%20traditional%20Korean%20clothing%20hanbok%2C%20ancient%20palace%20background%2C%20epic%20scale%2C%20traditional%20ink%20wash%20painting%20style%2C%20dramatic%20composition&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    category: '历史',
    categorySlug: 'historical',
    tags: ['历史', '武侠', '宫廷'],
    rating: 9.8,
    views: 3120000,
    likes: 178000,
    description: '朝鲜王朝中期，权臣当道，王室衰微。出身寒微的少年李萱在一次机缘巧合下获得了传说中的武学秘籍，从此踏上了匡扶正义的道路。从江湖到庙堂，从武学到权谋，他将在历史的大潮中书写属于自己的传奇。一段波澜壮阔的朝鲜风云录，即将揭开序幕。',
    chapters: [
      { id: 601, title: '第1话 乱世少年', number: 1, createdAt: '2025-09-01' },
      { id: 602, title: '第2话 奇遇', number: 2, createdAt: '2025-09-08' },
      { id: 603, title: '第3话 初入江湖', number: 3, createdAt: '2025-09-15' },
      { id: 604, title: '第4话 京城之路', number: 4, createdAt: '2025-09-22' },
      { id: 605, title: '第5话 殿试风云', number: 5, createdAt: '2025-09-29' },
      { id: 606, title: '第6话 暗流涌动', number: 6, createdAt: '2025-10-06' },
      { id: 607, title: '第7话 宫变', number: 7, createdAt: '2025-10-13' },
      { id: 608, title: '第8话 王者之路', number: 8, createdAt: '2025-10-20' },
    ],
    status: '连载中',
    updatedAt: '2026-08-02',
    createdAt: '2025-09-01',
  },
  {
    id: 7,
    title: '我的外星室友',
    author: '张欢乐',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20comedy%20comic%20cover%20with%20funny%20alien%20character%20in%20modern%20apartment%2C%20colorful%20and%20playful%20art%20style%2C%20slice%20of%20life%20comedy%2C%20bright%20vibrant%20colors%2C%20chibi%20style%20characters%2C%20humorous%20expression&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    category: '搞笑',
    categorySlug: 'comedy',
    tags: ['搞笑', '日常', '科幻'],
    rating: 9.2,
    views: 1980000,
    likes: 115000,
    description: '普通大学生李明浩某天回家发现自己的出租屋里多了一个来自外星的室友！这个叫"咕噜"的外星人不仅要学习地球生活，还总是闹出各种啼笑皆非的乌龙。从点外卖到坐地铁，从考试作弊到暗恋女生，咕噜的每一次"帮忙"都让事情变得更加混乱搞笑。',
    chapters: [
      { id: 701, title: '第1话 天上掉下个外星人', number: 1, createdAt: '2026-05-01' },
      { id: 702, title: '第2话 外卖大作战', number: 2, createdAt: '2026-05-08' },
      { id: 703, title: '第3话 考试作弊器', number: 3, createdAt: '2026-05-15' },
      { id: 704, title: '第4话 恋爱顾问咕噜', number: 4, createdAt: '2026-05-22' },
      { id: 705, title: '第5话 地铁惊魂', number: 5, createdAt: '2026-05-29' },
      { id: 706, title: '第6话 外星科技大促销', number: 6, createdAt: '2026-06-05' },
    ],
    status: '连载中',
    updatedAt: '2026-08-01',
    createdAt: '2026-05-01',
  },
  {
    id: 8,
    title: '镜中鬼',
    author: '韩秀贞',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20horror%20comic%20cover%20with%20cracked%20mirror%20and%20ghostly%20reflection%2C%20dark%20and%20eerie%20atmosphere%2C%20pale%20color%20palette%2C%20psychological%20horror%2C%20disturbing%20but%20beautiful%20art%2C%20creepy%20mood&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    category: '恐怖',
    categorySlug: 'horror',
    tags: ['恐怖', '灵异', '惊悚'],
    rating: 9.1,
    views: 1450000,
    likes: 78000,
    description: '女高中生朴秀雅搬进了一栋老旧公寓，房间里的古董镜子总是让她感到不安。每到午夜12点，镜子中就会出现一个面目模糊的黑影。随着调查的深入，她发现这面镜子与30年前一桩离奇失踪案有关。镜中的恶灵正在一步步逼近现实世界，而秀雅必须在下一个满月之夜到来前，揭开镜中鬼的秘密。',
    chapters: [
      { id: 801, title: '第1话 新家的镜子', number: 1, createdAt: '2026-06-01' },
      { id: 802, title: '第2话 午夜12点', number: 2, createdAt: '2026-06-08' },
      { id: 803, title: '第3话 30年前的失踪案', number: 3, createdAt: '2026-06-15' },
      { id: 804, title: '第4话 镜中人', number: 4, createdAt: '2026-06-22' },
      { id: 805, title: '第5话 满月之夜', number: 5, createdAt: '2026-06-29' },
    ],
    status: '连载中',
    updatedAt: '2026-07-30',
    createdAt: '2026-06-01',
  },
  {
    id: 9,
    title: '樱花树下的约定',
    author: '金秀妍',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romance%20comic%20cover%20with%20cherry%20blossom%20trees%2C%20young%20couple%20holding%20hands%2C%20spring%20atmosphere%2C%20soft%20pink%20and%20white%20colors%2C%20dreamy%20romantic%20mood%2C%20beautiful%20detailed%20character%20art&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['恋爱', '校园', '治愈'],
    rating: 9.3,
    views: 1120000,
    likes: 76000,
    description: '转学生安智雅在樱花盛开的季节来到了新的学校。在校园那棵最大的樱花树下，她遇见了正在画画的少年郑佑彬。一个关于音乐、绘画和青春的爱情故事，在樱花纷飞中悄然绽放。但毕业的钟声即将敲响，他们的约定能否在樱花树下实现？',
    chapters: [
      { id: 901, title: '第1话 樱花转学生', number: 1, createdAt: '2026-03-15' },
      { id: 902, title: '第2话 画笔下的你', number: 2, createdAt: '2026-03-22' },
      { id: 903, title: '第3话 音乐教室', number: 3, createdAt: '2026-03-29' },
      { id: 904, title: '第4话 学园祭', number: 4, createdAt: '2026-04-05' },
      { id: 905, title: '第5话 樱花雨', number: 5, createdAt: '2026-04-12' },
    ],
    status: '已完结',
    updatedAt: '2026-04-12',
    createdAt: '2026-03-15',
  },
  {
    id: 10,
    title: '龙之继承者',
    author: '李星辰',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20fantasy%20comic%20cover%20with%20dragon%20rider%2C%20epic%20fantasy%20landscape%2C%20flying%20dragon%2C%20medieval%20fantasy%20setting%2C%20dramatic%20sky%2C%20heroic%20pose%2C%20rich%20color%20palette&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['奇幻', '龙', '冒险'],
    rating: 9.5,
    views: 2340000,
    likes: 132000,
    description: '龙之大陆上，古老的龙骑士团已经消失了千年。普通铁匠学徒雷恩在一次意外中，发现自己是最后一位龙骑士的后裔。当沉睡的龙蛋在他手中孵化，一段史诗般的冒险就此开启。他必须穿越五大王国，寻找失落的龙之秘宝，阻止黑暗势力的阴谋。',
    chapters: [
      { id: 1001, title: '第1话 铁匠铺的秘密', number: 1, createdAt: '2026-01-01' },
      { id: 1002, title: '第2话 龙蛋孵化', number: 2, createdAt: '2026-01-08' },
      { id: 1003, title: '第3话 火焰试炼', number: 3, createdAt: '2026-01-15' },
      { id: 1004, title: '第4话 天空骑士', number: 4, createdAt: '2026-01-22' },
      { id: 1005, title: '第5话 黑暗来袭', number: 5, createdAt: '2026-01-29' },
      { id: 1006, title: '第6话 龙之谷', number: 6, createdAt: '2026-02-05' },
      { id: 1007, title: '第7话 王者归来', number: 7, createdAt: '2026-02-12' },
    ],
    status: '连载中',
    updatedAt: '2026-08-03',
    createdAt: '2026-01-01',
  },
  {
    id: 11,
    title: '格斗天王',
    author: '朴志勋',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20action%20fighting%20comic%20cover%20with%20martial%20arts%20fighter%20in%20dynamic%20pose%2C%20ring%20background%2C%20intense%20action%2C%20dramatic%20lighting%2C%20powerful%20energy%20effects%2C%20gritty%20realistic%20art%20style&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    tags: ['动作', '格斗', '热血'],
    rating: 9.4,
    views: 1760000,
    likes: 95000,
    description: '地下格斗界的传奇人物金泰成，在一次比赛中因为拒绝打假拳而被整个格斗界封杀。三年后，他以全新的身份重返擂台。这一次，他不仅要夺回属于自己的荣耀，更要揭露地下格斗界背后的黑暗勾当。拳拳到肉的格斗场面，热血澎湃的复仇之路。',
    chapters: [
      { id: 1101, title: '第1话 最后的比赛', number: 1, createdAt: '2026-02-15' },
      { id: 1102, title: '第2话 封杀令', number: 2, createdAt: '2026-02-22' },
      { id: 1103, title: '第3话 三年之后', number: 3, createdAt: '2026-03-01' },
      { id: 1104, title: '第4话 地下竞技场', number: 4, createdAt: '2026-03-08' },
      { id: 1105, title: '第5话 首战告捷', number: 5, createdAt: '2026-03-15' },
      { id: 1106, title: '第6话 幕后黑手', number: 6, createdAt: '2026-03-22' },
    ],
    status: '连载中',
    updatedAt: '2026-08-01',
    createdAt: '2026-02-15',
  },
  {
    id: 12,
    title: '完美不在场证明',
    author: '崔敏雅',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20mystery%20comic%20cover%20with%20crime%20scene%20tape%2C%20detective%20examining%20evidence%2C%20dark%20room%20with%20clues%2C%20noir%20atmosphere%2C%20suspenseful%20tone%2C%20intricate%20details%2C%20monochromatic%20with%20red%20accents&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    category: '悬疑',
    categorySlug: 'mystery',
    tags: ['悬疑', '推理', '犯罪'],
    rating: 9.6,
    views: 2080000,
    likes: 118000,
    description: '天才犯罪心理学家韩瑞俊被警方邀请协助调查一系列离奇的完美犯罪案件。每一起案件的嫌疑人都有无懈可击的不在场证明，但瑞俊坚信这背后一定有一个共同的联系。当他深入调查时，发现自己正在与一个智商极高的连环杀手进行一场致命的智力博弈。',
    chapters: [
      { id: 1201, title: '第1话 完美犯罪', number: 1, createdAt: '2026-04-15' },
      { id: 1202, title: '第2话 第一现场', number: 2, createdAt: '2026-04-22' },
      { id: 1203, title: '第3话 不在场证明', number: 3, createdAt: '2026-04-29' },
      { id: 1204, title: '第4话 心理画像', number: 4, createdAt: '2026-05-06' },
      { id: 1205, title: '第5话 第二个受害者', number: 5, createdAt: '2026-05-13' },
      { id: 1206, title: '第6话 棋逢对手', number: 6, createdAt: '2026-05-20' },
    ],
    status: '连载中',
    updatedAt: '2026-07-30',
    createdAt: '2026-04-15',
  },
  {
    id: 13,
    title: '财阀家的小女儿',
    author: '尹智恩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20drama%20comic%20cover%20with%20elegant%20young%20woman%20in%20luxury%20setting%2C%20chaebol%20family%20mansion%2C%20sophisticated%20fashion%2C%20dramatic%20lighting%2C%20rich%20color%20palette%2C%20cinematic%20composition&width=600&height=800&seq=comic-cover-13&orientation=portrait',
    category: '都市',
    categorySlug: 'urban',
    tags: ['都市', '豪门', '商战'],
    rating: 9.5,
    views: 2870000,
    likes: 156000,
    description: '作为韩国最大财阀家族最小的女儿，姜瑞妍从小就被当作家族联姻的工具。但她不甘心成为任何人的附属品。在家族企业的继承权争夺战中，她凭借自己的智慧和勇气，一步步在男性主导的商业世界中杀出一条血路。这是一个关于女性觉醒与成长的故事。',
    chapters: [
      { id: 1301, title: '第1话 家族晚宴', number: 1, createdAt: '2026-05-01' },
      { id: 1302, title: '第2话 继承者之战', number: 2, createdAt: '2026-05-08' },
      { id: 1303, title: '第3话 暗中布局', number: 3, createdAt: '2026-05-15' },
      { id: 1304, title: '第4话 并购计划', number: 4, createdAt: '2026-05-22' },
      { id: 1305, title: '第5话 棋局逆转', number: 5, createdAt: '2026-05-29' },
      { id: 1306, title: '第6话 新的开始', number: 6, createdAt: '2026-06-05' },
    ],
    status: '连载中',
    updatedAt: '2026-08-03',
    createdAt: '2026-05-01',
  },
  {
    id: 14,
    title: '高丽武僧传',
    author: '姜太浩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20historical%20martial%20arts%20comic%20cover%20with%20Buddhist%20warrior%20monk%2C%20ancient%20Korean%20temple%2C%20martial%20arts%20action%20pose%2C%20traditional%20ink%20painting%20style%2C%20zen%20atmosphere%2C%20epic%20composition&width=600&height=800&seq=comic-cover-14&orientation=portrait',
    category: '历史',
    categorySlug: 'historical',
    tags: ['历史', '武侠', '高丽'],
    rating: 9.7,
    views: 2230000,
    likes: 134000,
    description: '高丽王朝时期，少林武僧后裔释空大师隐居于金刚山的一座古寺中。当契丹铁骑踏破边境，他放下念珠、拿起棍棒，带领一批年轻僧人组成僧兵，誓死保卫家园。这是一部关于信仰、勇气和牺牲的史诗级历史武侠巨作。',
    chapters: [
      { id: 1401, title: '第1话 古寺钟声', number: 1, createdAt: '2025-12-01' },
      { id: 1402, title: '第2话 契丹入侵', number: 2, createdAt: '2025-12-08' },
      { id: 1403, title: '第3话 僧兵集结', number: 3, createdAt: '2025-12-15' },
      { id: 1404, title: '第4话 边境之战', number: 4, createdAt: '2025-12-22' },
      { id: 1405, title: '第5话 金刚伏魔', number: 5, createdAt: '2025-12-29' },
    ],
    status: '已完结',
    updatedAt: '2025-12-29',
    createdAt: '2025-12-01',
  },
  {
    id: 15,
    title: '废柴逆袭记',
    author: '张欢乐',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20comedy%20comic%20cover%20with%20underdog%20character%20transformation%2C%20before%20and%20after%20concept%2C%20funny%20and%20inspiring%20mood%2C%20bright%20colors%2C%20playful%20art%20style%2C%20slice%20of%20life%20comedy&width=600&height=800&seq=comic-cover-15&orientation=portrait',
    category: '搞笑',
    categorySlug: 'comedy',
    tags: ['搞笑', '励志', '逆袭'],
    rating: 9.3,
    views: 2010000,
    likes: 108000,
    description: '30岁的无业游民姜大浩，在一次意外触电后，突然获得了"废柴系统"——一个只会发布奇葩任务的AI。为了完成任务获得奖励，他不得不硬着头皮去做各种荒唐的事情。从学跳舞到练瑜伽，从考驾照到学外语，这个废柴在系统的"折磨"下，竟然一步步走上了人生巅峰？',
    chapters: [
      { id: 1501, title: '第1话 废柴的一天', number: 1, createdAt: '2026-06-01' },
      { id: 1502, title: '第2话 触电奇遇', number: 2, createdAt: '2026-06-08' },
      { id: 1503, title: '第3话 废柴系统的第一个任务', number: 3, createdAt: '2026-06-15' },
      { id: 1504, title: '第4话 跳舞吧废柴', number: 4, createdAt: '2026-06-22' },
      { id: 1505, title: '第5话 瑜伽大师养成中', number: 5, createdAt: '2026-06-29' },
      { id: 1506, title: '第6话 意外的面试', number: 6, createdAt: '2026-07-06' },
    ],
    status: '连载中',
    updatedAt: '2026-08-02',
    createdAt: '2026-06-01',
  },
  {
    id: 16,
    title: '寄生',
    author: '韩秀贞',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20horror%20comic%20cover%20with%20parasitic%20creature%2C%20body%20horror%20theme%2C%20dark%20laboratory%20setting%2C%20disturbing%20atmosphere%2C%20cold%20green%20and%20black%20color%20scheme%2C%20scientific%20horror%20aesthetic&width=600&height=800&seq=comic-cover-16&orientation=portrait',
    category: '恐怖',
    categorySlug: 'horror',
    tags: ['恐怖', '科幻', '丧尸'],
    rating: 9.0,
    views: 1320000,
    likes: 71000,
    description: '一家生物科技公司在进行秘密实验时发生了泄露事故，一种未知的寄生生物开始在首尔蔓延。被寄生的人会逐渐丧失自我意识，成为行尸走肉。医生金敏俊和他的团队必须在城市彻底沦陷之前找到解药。但随着时间的推移，他们发现这种寄生物的起源远比想象的更加恐怖。',
    chapters: [
      { id: 1601, title: '第1话 实验室事故', number: 1, createdAt: '2026-07-01' },
      { id: 1602, title: '第2话 零号病人', number: 2, createdAt: '2026-07-08' },
      { id: 1603, title: '第3话 蔓延', number: 3, createdAt: '2026-07-15' },
      { id: 1604, title: '第4话 隔离区', number: 4, createdAt: '2026-07-22' },
      { id: 1605, title: '第5话 寄生之源', number: 5, createdAt: '2026-07-29' },
    ],
    status: '连载中',
    updatedAt: '2026-08-03',
    createdAt: '2026-07-01',
  },
  {
    id: 17,
    title: '你是我眼中的星辰',
    author: '金秀妍',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romance%20comic%20cover%20with%20starry%20night%20sky%2C%20couple%20looking%20at%20stars%2C%20telescope%2C%20dreamy%20atmosphere%2C%20soft%20blue%20and%20purple%20tones%2C%20romantic%20and%20poetic%20mood%2C%20beautiful%20illustration&width=600&height=800&seq=comic-cover-17&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['恋爱', '天文', '治愈'],
    rating: 9.4,
    views: 890000,
    likes: 62000,
    description: '天文系研究生李星河和音乐系学生韩雨星，因为一次流星雨观测活动而相识。一个是理性严谨的科学青年，一个是感性浪漫的艺术少女。在星空之下，两个来自不同世界的人，开始了一段跨越科学与艺术的美妙恋曲。每一颗星星，都见证着他们的爱情。',
    chapters: [
      { id: 1701, title: '第1话 流星雨之夜', number: 1, createdAt: '2026-07-01' },
      { id: 1702, title: '第2话 天文台', number: 2, createdAt: '2026-07-08' },
      { id: 1703, title: '第3话 星图与乐谱', number: 3, createdAt: '2026-07-15' },
      { id: 1704, title: '第4话 日食之日', number: 4, createdAt: '2026-07-22' },
    ],
    status: '连载中',
    updatedAt: '2026-07-22',
    createdAt: '2026-07-01',
  },
  {
    id: 18,
    title: '魔法学院优等生',
    author: '李星辰',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20fantasy%20magic%20school%20comic%20cover%20with%20students%20casting%20spells%2C%20magical%20academy%20castle%2C%20colorful%20magic%20effects%2C%20adventure%20mood%2C%20young%20characters%2C%20vibrant%20fantasy%20illustration&width=600&height=800&seq=comic-cover-18&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['奇幻', '学院', '魔法'],
    rating: 9.1,
    views: 1450000,
    likes: 82000,
    description: '出身普通家庭的少女艾琳，凭借惊人的魔法天赋考入了王国最顶尖的星辰魔法学院。在这个精英云集的地方，她不仅要面对繁重的学业和严苛的考核，还要应对来自贵族学生们的刁难。但艾琳用自己的实力证明：天赋与努力，比血统更加重要。',
    chapters: [
      { id: 1801, title: '第1话 入学通知书', number: 1, createdAt: '2026-06-01' },
      { id: 1802, title: '第2话 分院仪式', number: 2, createdAt: '2026-06-08' },
      { id: 1803, title: '第3话 第一堂魔法课', number: 3, createdAt: '2026-06-15' },
      { id: 1804, title: '第4话 贵族们的挑衅', number: 4, createdAt: '2026-06-22' },
      { id: 1805, title: '第5话 魔法对决', number: 5, createdAt: '2026-06-29' },
    ],
    status: '连载中',
    updatedAt: '2026-07-28',
    createdAt: '2026-06-01',
  },
  {
    id: 19,
    title: '极速追击',
    author: '朴志勋',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20action%20car%20chase%20comic%20cover%20with%20sports%20car%20at%20high%20speed%2C%20night%20city%20highway%2C%20motion%20blur%20effect%2C%20intense%20action%2C%20neon%20lights%2C%20cinematic%20racing%20atmosphere&width=600&height=800&seq=comic-cover-19&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    tags: ['动作', '赛车', '犯罪'],
    rating: 9.2,
    views: 1230000,
    likes: 68000,
    description: '前赛车冠军郑在赫因为一起阴谋被诬陷入狱。出狱后，他发现当年的对手已经建立了一个利用地下赛车进行洗钱的犯罪帝国。为了洗刷冤屈，他必须重新握紧方向盘，在首尔深夜的街头展开最危险的极速追击。引擎的轰鸣声，是复仇的序曲。',
    chapters: [
      { id: 1901, title: '第1话 冠军陨落', number: 1, createdAt: '2026-05-15' },
      { id: 1902, title: '第2话 铁窗岁月', number: 2, createdAt: '2026-05-22' },
      { id: 1903, title: '第3话 重返街头', number: 3, createdAt: '2026-05-29' },
      { id: 1904, title: '第4话 地下竞速', number: 4, createdAt: '2026-06-05' },
      { id: 1905, title: '第5话 汉江狂飙', number: 5, createdAt: '2026-06-12' },
    ],
    status: '连载中',
    updatedAt: '2026-07-29',
    createdAt: '2026-05-15',
  },
  {
    id: 20,
    title: '时间回廊',
    author: '崔敏雅',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20time%20travel%20mystery%20comic%20cover%20with%20clock%20mechanisms%2C%20time%20loops%2C%20surreal%20atmosphere%2C%20golden%20gears%2C%20mysterious%20corridor%2C%20philosophical%20mood%2C%20intricate%20art%20style&width=600&height=800&seq=comic-cover-20&orientation=portrait',
    category: '悬疑',
    categorySlug: 'mystery',
    tags: ['悬疑', '时间', '科幻'],
    rating: 9.5,
    views: 1670000,
    likes: 96000,
    description: '物理学家林夕在一次粒子对撞实验中意外打开了一条时间回廊。她发现自己可以回到过去，但每次改变过去都会导致不可预知的后果。当她试图拯救在事故中去世的恋人时，时间线开始崩溃。在无限的时间回廊中，她必须找到那个能够拯救一切的关键节点。',
    chapters: [
      { id: 2001, title: '第1话 粒子对撞', number: 1, createdAt: '2026-07-01' },
      { id: 2002, title: '第2话 第一次穿越', number: 2, createdAt: '2026-07-08' },
      { id: 2003, title: '第3话 蝴蝶效应', number: 3, createdAt: '2026-07-15' },
      { id: 2004, title: '第4话 时间悖论', number: 4, createdAt: '2026-07-22' },
      { id: 2005, title: '第5话 回廊尽头', number: 5, createdAt: '2026-07-29' },
    ],
    status: '连载中',
    updatedAt: '2026-08-03',
    createdAt: '2026-07-01',
  },
  {
    id: 21,
    title: '社长大人请多指教',
    author: '尹智恩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20office%20romance%20comic%20cover%20with%20CEO%20and%20employee%2C%20modern%20office%20setting%2C%20professional%20yet%20romantic%20mood%2C%20fashionable%20business%20attire%2C%20warm%20lighting%2C%20sophisticated%20style&width=600&height=800&seq=comic-cover-21&orientation=portrait',
    category: '都市',
    categorySlug: 'urban',
    tags: ['都市', '职场', '恋爱'],
    rating: 9.1,
    views: 1560000,
    likes: 88000,
    description: '职场菜鸟申美兰误打误撞进入了韩国顶级科技公司。更令人意外的是，她的直属上司——公司最年轻的社长车贤宇，竟然是她的大学暗恋对象！在高压的职场环境中，两人的关系在专业与私人之间摇摆不定。这是一段关于职场成长与暗恋成真的甜蜜故事。',
    chapters: [
      { id: 2101, title: '第1话 面试奇遇', number: 1, createdAt: '2026-06-15' },
      { id: 2102, title: '第2话 我的社长是学长', number: 2, createdAt: '2026-06-22' },
      { id: 2103, title: '第3话 加班夜话', number: 3, createdAt: '2026-06-29' },
      { id: 2104, title: '第4话 项目危机', number: 4, createdAt: '2026-07-06' },
      { id: 2105, title: '第5话 出差', number: 5, createdAt: '2026-07-13' },
    ],
    status: '连载中',
    updatedAt: '2026-08-02',
    createdAt: '2026-06-15',
  },
  {
    id: 22,
    title: '三国遗事：新罗传说',
    author: '姜太浩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20historical%20Silla%20dynasty%20comic%20cover%20with%20ancient%20Korean%20warriors%2C%20golden%20crown%2C%20traditional%20architecture%2C%20mythological%20elements%2C%20epic%20scale%2C%20rich%20gold%20and%20crimson%20colors&width=600&height=800&seq=comic-cover-22&orientation=portrait',
    category: '历史',
    categorySlug: 'historical',
    tags: ['历史', '神话', '新罗'],
    rating: 9.6,
    views: 1980000,
    likes: 121000,
    description: '以《三国遗事》为蓝本，讲述新罗王朝的传奇故事。从朴赫居世的诞生到金庾信的英勇，从善德女王的政治智慧到花郎道的精神传承。这是一部将历史与神话完美融合的史诗级作品，带您领略古代新罗的辉煌与神秘。',
    chapters: [
      { id: 2201, title: '第1话 卵生神话', number: 1, createdAt: '2026-04-01' },
      { id: 2202, title: '第2话 六部之盟', number: 2, createdAt: '2026-04-08' },
      { id: 2203, title: '第3话 花郎道的诞生', number: 3, createdAt: '2026-04-15' },
      { id: 2204, title: '第4话 善德女王的预言', number: 4, createdAt: '2026-04-22' },
      { id: 2205, title: '第5话 金庾信出征', number: 5, createdAt: '2026-04-29' },
      { id: 2206, title: '第6话 三国一统', number: 6, createdAt: '2026-05-06' },
    ],
    status: '已完结',
    updatedAt: '2026-05-06',
    createdAt: '2026-04-01',
  },
  {
    id: 23,
    title: '便利店夜班日记',
    author: '张欢乐',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20comedy%20comic%20cover%20with%20convenience%20store%20at%20night%2C%20quirky%20customers%2C%20warm%20neon%20lights%2C%20slice%20of%20life%20humor%2C%20cozy%20atmosphere%2C%20colorful%20characters%2C%20relatable%20comedy&width=600&height=800&seq=comic-cover-23&orientation=portrait',
    category: '搞笑',
    categorySlug: 'comedy',
    tags: ['搞笑', '日常', '治愈'],
    rating: 9.4,
    views: 1780000,
    likes: 103000,
    description: '大学生金智浩为了赚生活费，在一家24小时便利店做夜班兼职。每到深夜，便利店就变成了一个奇妙的小世界——失恋的上班族、深夜觅食的吃货、逃家的少年、写不出稿子的作家……形形色色的人在深夜的便利店相遇，发生了各种温暖又有趣的故事。',
    chapters: [
      { id: 2301, title: '第1话 第一个夜班', number: 1, createdAt: '2026-07-01' },
      { id: 2302, title: '第2话 深夜的常客们', number: 2, createdAt: '2026-07-08' },
      { id: 2303, title: '第3话 泡面哲学', number: 3, createdAt: '2026-07-15' },
      { id: 2304, title: '第4话 失恋的上班族', number: 4, createdAt: '2026-07-22' },
      { id: 2305, title: '第5话 深夜食堂', number: 5, createdAt: '2026-07-29' },
    ],
    status: '连载中',
    updatedAt: '2026-08-03',
    createdAt: '2026-07-01',
  },
  {
    id: 24,
    title: '鬼校',
    author: '韩秀贞',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20school%20horror%20comic%20cover%20with%20haunted%20school%20building%2C%20ghostly%20figures%2C%20dark%20corridors%2C%20eerie%20atmosphere%2C%20pale%20blue%20lighting%2C%20Asian%20horror%20aesthetic%2C%20creepy%20school%20uniform&width=600&height=800&seq=comic-cover-24&orientation=portrait',
    category: '恐怖',
    categorySlug: 'horror',
    tags: ['恐怖', '校园', '灵异'],
    rating: 9.2,
    views: 1560000,
    likes: 84000,
    description: '一所废弃了二十年的高中即将被拆除，五个大学生决定在拆除前夜进入探险。然而，当午夜的钟声响起，学校的时空发生了扭曲，他们发现自己回到了二十年前——那个发生了一系列学生离奇死亡事件的时代。想要活着离开，就必须找出当年真相。',
    chapters: [
      { id: 2401, title: '第1话 废弃校园', number: 1, createdAt: '2026-07-15' },
      { id: 2402, title: '第2话 进入鬼校', number: 2, createdAt: '2026-07-22' },
      { id: 2403, title: '第3话 时空扭曲', number: 3, createdAt: '2026-07-29' },
      { id: 2404, title: '第4话 二十年前的同班同学', number: 4, createdAt: '2026-08-05' },
    ],
    status: '连载中',
    updatedAt: '2026-08-05',
    createdAt: '2026-07-15',
  },
];

export function getComicsByCategory(slug: string): Comic[] {
  return comics.filter((c) => c.categorySlug === slug);
}

export function getComicById(id: number): Comic | undefined {
  return comics.find((c) => c.id === id);
}

export function getHotComics(limit: number = 8): Comic[] {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, limit);
}

export function getLatestComics(limit: number = 10): Comic[] {
  return [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, limit);
}

export function getRankedComics(limit: number = 10): Comic[] {
  return [...comics].sort((a, b) => b.rating - a.rating).slice(0, limit);
}

export function getRelatedComics(comic: Comic, limit: number = 4): Comic[] {
  return comics.filter((c) => c.categorySlug === comic.categorySlug && c.id !== comic.id).slice(0, limit);
}